export default "__VITE_ASSET__CM20LZjH__"